import { Link } from "@/components/LLink";
import { ArrowUpRight } from "lucide-react";

export default function OverlapFeature({ image, alt, kicker, title, paragraphs, href, linkLabel, reverse = false, testid }) {
  return (
    <div className="relative grid items-center lg:grid-cols-12" data-testid={testid}>
      <div className={`lg:col-span-8 lg:row-start-1 ${reverse ? "lg:col-start-5" : "lg:col-start-1"}`}>
        <div className="aspect-[2/1] overflow-hidden rounded-md border border-ink/10 bg-surface">
          <img src={image} alt={alt} className="h-full w-full object-cover" loading="lazy" />
        </div>
      </div>
      <div className={`relative z-10 -mt-12 px-4 lg:col-span-7 lg:row-start-1 lg:mt-0 lg:translate-y-14 lg:px-0 ${reverse ? "lg:col-start-1" : "lg:col-start-6"}`}>
        <div className="rounded-md border border-ink/5 bg-base px-8 py-7 shadow-2xl shadow-black/10 lg:px-10 lg:py-8">
          <div className="flex items-start justify-between gap-6">
            <div>
              <p className="text-[12px] font-semibold uppercase tracking-[0.25em] text-gold">{kicker}</p>
              <h3 className="mt-2 font-heading text-2xl font-semibold leading-tight text-ink">{title}</h3>
            </div>
            <Link to={href} aria-label={linkLabel} data-testid={`${testid}-arrow`} className="flex h-11 w-11 shrink-0 items-center justify-center bg-ink text-base transition-colors hover:bg-gold">
              <ArrowUpRight className="h-5 w-5" />
            </Link>
          </div>
          <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-ink/65">
            {paragraphs.map((p) => <p key={p}>{p}</p>)}
          </div>
          <Link to={href} data-testid={`${testid}-link`} className="mt-5 inline-flex items-center gap-2 text-[14px] font-semibold text-ink underline decoration-gold decoration-2 underline-offset-[6px] transition-colors hover:text-gold">
            {linkLabel}
          </Link>
        </div>
      </div>
    </div>
  );
}
